
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.579 0a3.35 3.35 0 00-3.342 3.342A3.34 3.34 0 003.525 5.97a5.571 5.571 0 00-3.516 5.169.557.557 0 00.557.556h4.369a5.491 5.491 0 00-.47 2.228.557.557 0 00.557.557h10.024a.557.557 0 00.557-.557c0-.795-.168-1.543-.47-2.228h4.369a.557.557 0 00.557-.556 5.571 5.571 0 00-3.516-5.17 3.34 3.34 0 001.288-2.627A3.35 3.35 0 0014.489 0a3.354 3.354 0 00-3.324 2.985 3.304 3.304 0 00-2.262 0A3.354 3.354 0 005.579 0zm0 1.114a2.22 2.22 0 012.227 2.228V3.646a3.346 3.346 0 00-1.01 1.67.555.555 0 00-.051.018c-.216.097-.87.235-1.166.235A2.22 2.22 0 013.35 3.342a2.22 2.22 0 012.228-2.228zm8.91 0a2.22 2.22 0 012.228 2.228 2.22 2.22 0 01-2.228 2.227c-.296 0-.95-.138-1.166-.235a.552.552 0 00-.052-.017 3.346 3.346 0 00-1.01-1.67V3.341a2.22 2.22 0 012.228-2.228zm-4.455 2.785a2.22 2.22 0 012.228 2.227 2.22 2.22 0 01-2.228 2.228 2.22 2.22 0 01-2.228-2.228A2.22 2.22 0 0110.034 3.9zM6.719 6.527c.109.9.58 1.693 1.261 2.227a5.593 5.593 0 00-2.384 1.828H1.175A4.432 4.432 0 015.58 6.683h.052a.558.558 0 00.06-.009c.33-.01.69-.053 1.028-.147zm6.63 0c.34.095.704.138 1.036.147a.633.633 0 00.026.01h.078a4.432 4.432 0 014.403 3.898H14.49a.51.51 0 00-.017 0 5.592 5.592 0 00-2.384-1.828 3.345 3.345 0 001.261-2.227zm-3.315 2.94a4.432 4.432 0 014.403 3.9H5.631a4.432 4.432 0 014.403-3.9z","fill":"#D0DAE6"}}),_c('path',{attrs:{"d":"M10.034 9.468a4.432 4.432 0 014.403 3.898H5.631a4.432 4.432 0 014.403-3.898z","fill":"#D0DAE6"}})])
          )
        }
      }
    